import { h, svgUse } from '../utils/dom.js';
import { t } from '../i18n/index.js';
import { StudyBot } from '../components/features/bot/StudyBot.js';
import { JourneyCard } from '../components/features/dashboard/JourneyCard.js';
import { emit, EVENT } from '../utils/events.js';
import { api } from '../api/client.js';
import { ENDPOINTS } from '../api/endpoints.js';

export function DashboardPage() {
  const goTo = (tab) => emit(EVENT.TAB_REQUESTED, tab);

  const launchGame = async () => {
    const gameWindow = window.open('', '_blank');
    if (gameWindow) gameWindow.opener = null;

    try {
      const res = await api.get(ENDPOINTS.game.launch());
      if (res && res.url) {
        if (gameWindow) gameWindow.location.replace(res.url);
        else window.location.assign(res.url);
      } else if (gameWindow) {
        gameWindow.close();
      }
    } catch (err) {
      if (gameWindow) gameWindow.close();
      console.error('Game launch failed:', err);
    }
  };

  return h('div', { class: 'page active' },
    h('div', { class: 'banner' },
      h('div', { class: 'floaties' },
        svgUse('ic-book2'),
        svgUse('ic-cpu'),
        svgUse('ic-globe'),
        svgUse('ic-chart'),
      ),
      h('h1', {}, t('dashHeroT')),
      h('p', {}, t('dashHeroD')),
    ),
    h('div', { class: 'dash-grid' },
      h('div', { class: 'journey-col' },
        h('h2', { class: 'journey-title' }, t('journeyTitle')),
        h('div', { class: 'journey-cards' },
          JourneyCard({
            icon: 'ic-gamepad',
            title: t('gameTitle'),
            desc: t('gameDesc'),
            badge: t('gameBadge'),
            actionLabel: t('playNow'),
            variant: 'game',
            onSelect: launchGame,
          }),
          JourneyCard({
            icon: 'ic-books',
            title: t('scenTitle'),
            desc: t('scenDesc'),
            badge: t('scenarioBadge'),
            actionLabel: t('exploreNow'),
            variant: 'scenario',
            onSelect: () => goTo('scenarios'),
          }),
        ),
      ),
    ),
    h('p', { class: 'tagline-strip' }, t('tagline')),
    StudyBot(),
  );
}
